import request from '@/utils/request'

const baseUrl = '/erp/finance/report/accounts-payable-summary'

export function pageAccountsPayableSummaryReport (params) {
  return request({
    url: `${baseUrl}/page`,
    method: 'get',
    params
  })
}

export function listAccountsPayableSummarySupplierOptions () {
  return request({
    url: `${baseUrl}/supplier-options`,
    method: 'get'
  })
}

export function exportAccountsPayableSummaryReport (params) {
  return request({
    url: `${baseUrl}/export`,
    method: 'get',
    params,
    responseType: 'blob'
  })
}
